/* FURBO BARENO — theme.js */
(function () {
  'use strict';

  var drawer = document.getElementById('NavDrawer');
  // ドロワーはヘッダー(transform持ち)の外へ出す（fixedをビューポート基準にする）
  if (drawer && drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }

  function setDrawer(open) {
    if (open) {
      var h = document.getElementById('shopify-section-header') || document.querySelector('[data-header]');
      if (h) h.classList.remove('is-hidden');
    }
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    var t = document.querySelector('[data-menu-toggle][aria-controls]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    // ハンバーガー / 閉じるボタン / 背景 でドロワー開閉
    if (e.target.closest('[data-menu-toggle]')) {
      e.preventDefault();
      setDrawer(!(drawer && drawer.classList.contains('is-open')));
      return;
    }
    // 商品ページ: サムネイルでメイン画像切替
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = thumb.getAttribute('data-full') || thumb.src;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  // ヘッダー: 下スクロールで隠す / 上スクロールで表示
  var header = document.getElementById('shopify-section-header') || document.querySelector('[data-header]');
  if (header) {
    var lastY = window.pageYOffset || 0;
    var ticking = false;
    var TH = 6; // ちらつき防止のしきい値
    function onScroll() {
      var y = window.pageYOffset || 0;
      header.classList.toggle('is-stuck', y > 4);
      if (y > 140 && y > lastY + TH) {
        header.classList.add('is-hidden');       // 下スクロール → 隠す
      } else if (y < lastY - TH) {
        header.classList.remove('is-hidden');     // 上スクロール → 表示
      }
      if (y <= 4) header.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }

  // ページ見出し(記事タイトル等)を可能な範囲で1行に収める
  // 上限=CSSのfont-size / 下限=20px。20pxでも入らない時だけ折り返す。
  function fitHeroTitles() {
    var els = document.querySelectorAll('.page-hero h1');
    Array.prototype.forEach.call(els, function (el) {
      el.style.whiteSpace = 'nowrap';
      el.style.fontSize = '';
      var min = 20;
      var size = parseFloat(window.getComputedStyle(el).fontSize) || 34;
      var guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && size > min && guard < 120) {
        size -= 1; el.style.fontSize = size + 'px'; guard++;
      }
      if (el.scrollWidth > el.clientWidth + 1) {   // それでも入らなければ折り返す
        el.style.whiteSpace = 'normal';
        el.style.fontSize = min + 'px';
      }
    });
  }
  fitHeroTitles();
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitHeroTitles); }
  var _rt;
  window.addEventListener('resize', function () { clearTimeout(_rt); _rt = setTimeout(fitHeroTitles, 150); });
})();